/**
 * Il segno di riconoscimento delle operazioni agentiche (F-144, SPEC-025).
 *
 * Un solo componente, usato ovunque una cosa sia stata prodotta da uno studio
 * con gli strumenti — la riga dell'innesco nelle Automazioni, la card del run
 * di auto-trading, lo storico e il dettaglio di un briefing, la catena di
 * riconciliazione. La forma è sempre la stessa (icona, tinta `accent`, parola
 * «agentico») perché il lettore deve poterla riconoscere a colpo d'occhio
 * senza rileggere: è la stessa scelta fatta per il trigger su valore (SPEC-019).
 *
 * Il `detail` facoltativo aggiunge un chiarimento in coda («2 fasi · 1
 * standard», «pre-chiusura di Nasdaq») senza rompere la forma del badge.
 */

import { Badge } from '@/ui';

export function AgenticBadge({ detail, title }: { detail?: string; title?: string }) {
  return (
    <Badge
      tone="accent"
      title={
        title ??
        'Prodotto da uno studio agentico: il modello ha interrogato strumenti (quotazioni, analisi, notizie, vincoli) prima di concludere. Prompt e ragionamento sono consultabili nel run.'
      }
    >
      <span aria-hidden="true">🤖</span> agentico
      {detail && <span className="agentic-badge__detail"> · {detail}</span>}
    </Badge>
  );
}
